import { useDesignMaxTheme } from "@/packages";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { BookBar, DateSearchBar, PieceBanner } from "@domains/common";
import { useGetReserve, type ReserveBaseResponse } from "@shared/server";
import { FONT } from "@styles/common";
import { ReservationList } from "./components";

export const Reservation = () => {
    const { data } = useGetReserve<ReserveBaseResponse>({ section: "reserve" });
    const { isLaptop } = useDesignMaxTheme().MEDIAS();

    return data ? (
        <Box w="100%" position="relative">
            <PieceBanner
                imgUrl={data.imgUrl}
                name={data.pensionInfo.name}
                title={{
                    main: "Reservation",
                    sub: "실시간 예약조회",
                }}
            />
            <Center
                as="section"
                p={isLaptop ? "64px 20px" : "128px 0 64px"}
                position="relative"
                flexDir="column"
                rowGap="36px"
            >
                <DateSearchBar isSubMenu={false} />
                <Text as="h5" sx={{ ...FONT("pretendard", 24, 700) }}>
                    객실 선택
                </Text>
                <ReservationList />
            </Center>
            <BookBar />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
